import 'slick-carousel';

// TODO: https://github.com/kenwheeler/slick/issues/179

function Carousel() {
  const self = this;

  self.init = function init(element) {
    const $wrap = $(element);

    if ($wrap.data('app-module-initialized')) return; // Prevent double init

    const $list = $wrap.find('.js-carousel__list');
    const $prev = $wrap.find('.js-carousel__prev');
    const $next = $wrap.find('.js-carousel__next');
    const $dots = $wrap.find('.js-carousel__dots');
    const params = $wrap.data('params');

    let slidesToShowTabletMini = 1;
    let slidesToShowTablet = 1;
    let slidesToShowDesktop = 1;

    if (params.slidesToShowTabletMini) slidesToShowTabletMini = params.slidesToShowTabletMini;
    else if (params.slidesToShow) slidesToShowTabletMini = params.slidesToShow;

    if (params.slidesToShowTablet) slidesToShowTablet = params.slidesToShowTablet;
    else if (params.slidesToShowTabletMini) slidesToShowTablet = params.slidesToShowTabletMini;
    else if (params.slidesToShow) slidesToShowTablet = params.slidesToShow;

    if (params.slidesToShowDesktop) slidesToShowDesktop = params.slidesToShowDesktop;
    else if (params.slidesToShowTablet) slidesToShowDesktop = params.slidesToShowTablet;
    else if (params.slidesToShowTabletMini) slidesToShowDesktop = params.slidesToShowTabletMini;
    else if (params.slidesToShow) slidesToShowDesktop = params.slidesToShow;




    const defaults = {
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      mobileFirst: true,
      dots: false,
      appendDots: $dots,
      speed: 600,
      prevArrow: $prev,
      nextArrow: $next,
      responsive: [
        {
          breakpoint: 576,
          settings: {
            slidesToShow: slidesToShowTabletMini,
          },
        },
        {
          breakpoint: 769,
          settings: {
            slidesToShow: slidesToShowTablet,
          },
        },
        {
          breakpoint: 1066,
          settings: {
            slidesToShow: slidesToShowDesktop,
          },
        },
      ],
    };



    const config = { ...defaults, ...params };

    console.log('params', config);

    $list.on('init', () => {
      $wrap.addClass('_initialized');
    });

    $list.slick(config);

    $wrap.data('app-module-initialized', true);
  };

  self.initAll = function initAll() {
    $('.js-carousel').each(function init() {
      self.init(this);
    });
  };
}

export default new Carousel();
